import { AssetMarker } from './AssetMarker';
import { Asset } from 'types/asset';
import 'leaflet.markercluster';
import MarkerClusterGroup from 'react-leaflet-cluster'
import { observer } from 'mobx-react';
import { useMapStore } from 'contexts/RootStore.context';
import useDevice from 'hooks/useDevice';
import { AssetFlyout } from 'views/assets/AssetFlyout/AssetFlyout';
import { useMemo } from 'react';
import L from 'leaflet';
import { style } from 'typestyle';
import { colours } from 'styling/colours';
import { MAX_ZOOM_FOR_DISPLAY_CLUSTERS } from 'stores/MapStore';

type AssetMarkersProps = {
  assets: Asset[];
};

export const AssetMarkers = observer(({ assets }: AssetMarkersProps) => {

  const { selectedBeaconId, assets: allAssets, selectBeacon, loadAssets, mapZoom } = useMapStore()
  const { isMobileDevice } = useDevice()

  const selectedAsset = useMemo(() => {
    if (selectedBeaconId) {
      return allAssets.find(asset => asset.assigned_beacon?.id === selectedBeaconId)
    }
    return undefined
  }, [allAssets, selectedBeaconId])

  return (
    <>
      {mapZoom < MAX_ZOOM_FOR_DISPLAY_CLUSTERS
        ? (
          <MarkerClusterGroup
            iconCreateFunction={(cluster: any) => {
              const count = cluster.getChildCount();
              return new L.DivIcon({
                html: `<div>${count}</div>`,
                className: ClusterStyle,
                iconSize: L.point(40, 40, true),
              });
            }}
            chunkedLoading
            maxClusterRadius={80}
            spiderfyOnMaxZoom
            showCoverageOnHover={true}
          >
            {assets.map((asset) => {
              return <AssetMarker key={asset.asset_id} asset={asset} />;
            })}
          </MarkerClusterGroup>
        )
        : assets.map((asset) => {
          return <AssetMarker key={asset.asset_id} asset={asset} />;
        })
      }
      {selectedBeaconId && selectedAsset && isMobileDevice && (
        <AssetFlyout asset={selectedAsset}
          onClose={() => selectBeacon(null)}
          hideAssetActivity
          onStatusUpdate={loadAssets} />
      )}
    </>
  );
})

const ClusterStyle = style({
  background: colours.secondaryText,
  borderRadius: '50%',
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 'bold'
})